import React from 'react';
import Page from "./templates/Page";
import { Link } from 'react-router-dom';

export default function Home() {

    return (
        <Page>
            <h1>Home</h1>
            <Link to="/projects">Projects</Link>
        </Page>
    )
}